<ion-header>
  <div class="header-arc"></div>
  <svg width="414" height="24" viewBox="0 0 414 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M415 0H0V24C182.72 -17.7778 347.085 6.51852 415 24V0Z" fill="#FFFAE6" />
  </svg>
</ion-header>
<div class="th add-parameter-container">
  <ion-row class="d-desc">
    <ion-col>
      <div class="title">
        <ion-icon (click)="onClose()" name="arrow-back"></ion-icon>
        <ion-label class="finding_label">
          {{'Select user' | translate}}
        </ion-label>
      </div>
    </ion-col>
  </ion-row>

  <ion-row class="search-bar-row">
    <ion-col>
      <div class="search-bar-div">
        <ion-searchbar mode="ios" placeholder="{{'Search in country directory' | translate}}" [formControl]="searchControl"
          id="searchText"   (ionClear)="onSearchClear($event)"
 (ionFocus)="onSearchFocus($event)" (ionInput)="onSearchInput($event)"></ion-searchbar>
      </div>
    </ion-col>
  </ion-row>

  <span class="" *ngIf="!usersListing">
    <ion-row>
      <div class="user-section">
        <div class="section-title">Site manager</div>

        <ion-chip class="email-chip" outline="true" (click)="onSelectManager(this.siteManagerInfo)">
          <ion-label class="email-text">{{this.siteManagerInfo?.id || "No site manager Assigned." }}</ion-label>
        </ion-chip>
      </div>

      <div class="section-divider"></div>
    </ion-row>
  </span>

  <span class="" *ngIf="!usersListing">
    <ion-row>
      <div class="user-section">
        <div class="section-title">Area owner</div>

        <ion-chip class="email-chip" outline="true" (click)="onSelectOwner(this.siteOwnerInfo)">
          <ion-label class="email-text">{{this.siteOwnerInfo?.email || "No area owner Assigned." }}</ion-label>
        </ion-chip>
      </div>

      <div class="section-divider"></div>
    </ion-row>
  </span>

  <span class="" *ngIf="!usersListing && lastFiveAssignedTo?.length > 0">
    <ion-row>
      <div class="user-section">
        <div class="section-title">Recently selected</div>

        <ion-chip class="email-chip" outline="true" *ngFor="let user of lastFiveAssignedTo" (click)="selectUser(user)">
          <ion-label class="email-text">{{user?.email}}</ion-label>
        </ion-chip>
      </div>

     
    </ion-row>
  </span>




  <div *ngIf="usersListing" class="user-selection-list" >
    <div class="user-list-aligment">
      <div *ngFor="let item of usersList">
        <ion-row class="assign-model-user-row" (click)="userSelected(item)">
          <ion-col class="assign-modal-user-photo-list-col">
            <div class="user-item">
              <div>
                 <ion-icon *ngIf="!item.profile_image" class="assign-modal-dummy-user-css" name="person-circle-outline"
                    ></ion-icon>
                  <img *ngIf="item.profile_image" class="assign-modal-dummy-user-css" src={{item.profile_image}}>
              </div>
              <div class="assign-modal-email-col-div">
                <div class="assign-modal-user-name">{{item.Full_Name || item.full_name || ((item.Fname || item.first_name || item.First_Name || '') + ' ' + (item.Lname || item.last_name || item.Last_Name || '')).trim() || item.email}}</div>
                <div class="assign-modal-user-email">{{item.email}}</div>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </div>
    </div>
  </div>

</div>

